import { useEffect, useState } from "react";
import { useWalletContext } from "../../../hooks/wallet-context";
import { myMileage } from "../../../../../../api/member";
import {
  getPubProducts,
  PayPubProductDto,
  payPubProductInApp,
  PayPubProductInAppRequest,
  PubProductResponse,
} from "../../../../../../api/pub-product";
import { enqueueSnackbar } from "notistack";

const useOrder = () => {
  const [loading, setLoading] = useState(true);
  const [mileage, setMileage] = useState(0);
  const { selectedFranchisePub } = useWalletContext();
  const [products, setProducts] = useState<PubProductResponse[]>([]);

  const [cart, setCart] = useState<PayPubProductDto[]>([]);
  const [seat, setSeat] = useState<number | null>(null);
  const [table, setTable] = useState<string | null>(null);
  const [isPickUp, setIsPickUp] = useState<boolean>(true);
  const [memo, setMemo] = useState<string>("");

  const [openProductCart, setOpenProductCart] = useState<boolean>(false);

  const [selectedProduct, setSelectedProduct] =
    useState<PubProductResponse | null>(null);

  async function getPubMileage() {
    if (!selectedFranchisePub) return;
    setLoading(true);
    const res = await myMileage(selectedFranchisePub.id);
    setMileage(res);
  }

  async function getPubProductList() {
    if (!selectedFranchisePub) return;
    const res = await getPubProducts(selectedFranchisePub.id);
    setProducts(res);
    setTimeout(() => {
      setLoading(false);
    }, 200);
  }

  useEffect(() => {
    getPubMileage();
    getPubProductList();
    setCart([]);
    setSeat(null);
    setTable(null);
    setIsPickUp(true);
    setMemo("");
  }, [selectedFranchisePub]);

  async function payPubProduct() {
    if (cart.length === 0) {
      enqueueSnackbar("장바구니에 상품을 추가해주세요. ", { variant: "error" });
      return;
    }
    if (!selectedFranchisePub) return;
    const request: PayPubProductInAppRequest = {
      pubId: selectedFranchisePub.id,
      payPubProductDtos: cart,
      seat: seat,
      table: table,
      isPickUp: isPickUp,
      memo: memo || "",
    };
    try {
      await payPubProductInApp(request);
      //주문 성공 팝업
    } catch (e: any) {
      throw e;
    }
  }

  return {
    mileage,
    products,
    cart,
    seat,
    table,
    isPickUp,
    memo,
    selectedProduct,
    setCart,
    setSeat,
    setTable,
    setIsPickUp,
    setMemo,
    setSelectedProduct,
    payPubProduct,
    loading,
    openProductCart,
    setOpenProductCart,
    setMileage,
  };
};

export default useOrder;
